import { Typography } from '@mui/material'
import React from 'react'

export default function CampaignRemainingData({selectedData}) {
  return (
    <Typography variant='h5'>{selectedData.join(' , ')}</Typography>
  )
}